import React  from 'react';
import GatewayRegistryBasicInfoComponent from './gateway-registries-basic-info.component';
import GatewayRedisAndLogisticsInfoComponent from './gateway-redis-logistics-info.component';
import GatewaySettingsInfoComponent from './gateway-settings-info.component';
import GatewayDomainsInfoComponent from './gateway-domain-info.component';
import GatewayWhiteListedRoutesInfoComponent from './gateway-white-listed-info.component';
import GatewayBlacklistedNPsInfoComponent from './gateway-black-listed-info.component';
import GatewayIncludedCitiesForCatalogInfoComponent from './gateway-included-cities-info.component';
import GatewayExcludedCitiesForCatalogInfoComponent from './gateway-excluded-cities-info.component';
import GatewayMaskedKeywordsInfoComponent from './gateway-masked-keywords.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
  export const GlobalDBAGatewayRegistryComponent = ({gateways,domains,maskedKeywords,excludedCitiesForCatalog,includedCitiesForCatalog,blacklistedNPs,whitelistedRoutes,handleFormMaskedKeywordsItemChange,handleFormExcludedCitiesForCatalogItemChange,handleFormIncludedCitiesForCatalogItemChange,handleFormBlacklistedNPsItemChange,handleFormWhitelistedRoutesItemChange,handleFormDomainsItemChange,stores,handleFormChange,selectedGateway,handleInnerFormChange,domainDetails,networks,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<GatewayRegistryBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        handleFormChange={handleFormChange}
        selectedGateway={selectedGateway}
        gateways={gateways}
        />,
    isVisible:true,
    },
    {
        id:2,
        title:'Settings',
        component:<GatewaySettingsInfoComponent 
        handleFormChange={handleFormChange}
        selectedGateway={selectedGateway}
        stores={stores}
        />,
    isVisible:true,
    },
    {
      id:3,
      title:'Domains Details',
      component:<GatewayDomainsInfoComponent 
      handleFormDomainsItemChange={handleFormDomainsItemChange}
      domains={domains}
      />,
  isVisible:true,
  },
    {
        id:4,
        title:'WhitelistedRoutes',
        component:<GatewayWhiteListedRoutesInfoComponent 
        handleFormWhitelistedRoutesItemChange={handleFormWhitelistedRoutesItemChange}
        whitelistedRoutes={whitelistedRoutes}
        />,
    isVisible:true,
    },
    {
        id:5,
        title:'BlacklistedNPs',
        component:<GatewayBlacklistedNPsInfoComponent 
        handleFormBlacklistedNPsItemChange={handleFormBlacklistedNPsItemChange}
        blacklistedNPs={blacklistedNPs}
        />,
    isVisible:true,
    },
    {
        id:6,
        title:'Included Cities For Catalog',
        component:<GatewayIncludedCitiesForCatalogInfoComponent 
        handleFormIncludedCitiesForCatalogItemChange={handleFormIncludedCitiesForCatalogItemChange}
        includedCitiesForCatalog={includedCitiesForCatalog}
        />,
    isVisible:true,
    },
    {
        id:7,
        title:'Excluded Cities For Catalog',
        component:<GatewayExcludedCitiesForCatalogInfoComponent 
        handleFormExcludedCitiesForCatalogItemChange={handleFormExcludedCitiesForCatalogItemChange}
        excludedCitiesForCatalog={excludedCitiesForCatalog}
        />,
    isVisible:true,
    },
    {
        id:8,
        title:'MaskedKeywords',
        component:<GatewayMaskedKeywordsInfoComponent 
        handleFormMaskedKeywordsItemChange={handleFormMaskedKeywordsItemChange}
        maskedKeywords={maskedKeywords}
        />,
    isVisible:true,
    },
    {
      id:9,
      title:'Redis & Logistics Info',
      component:<GatewayRedisAndLogisticsInfoComponent 
      handleFormChange={handleFormChange}
      selectedGateway={selectedGateway}
      />,
  isVisible:true,
  },
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default GlobalDBAGatewayRegistryComponent;
